import { useContext, useEffect, useState } from 'react';
import { drilldownDecorator } from 'reporting-ui-components/reports/decorators/drilldownDecorator';
// @ts-expect-error Untyped dependency
import { reportsEqual } from 'reporting-ui-components/lib/shallowCompareReports';
import { useSortableReport } from './useSortableReport';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { FiscalYearContext } from './FiscalYearProvider';
import { AsyncStatus } from 'reporting-data/asyncData/AsyncStatus';
import { isFailed, isSucceeded } from 'reporting-data/asyncData/AsyncData';
export function useEnhancedReport(asyncReport, {
  allowDrilldown = true,
  allowSort = true,
  hasCustomVisualize = false
} = {}, onReportChange) {
  const [enhancedReport, setEnhancedReport] = useState({
    status: AsyncStatus.UNINITIALIZED
  });
  const [previousReport, setPreviousReport] = useState(undefined);
  const sortableAsyncReport = useSortableReport(asyncReport, allowSort, onReportChange);
  const {
    gates
  } = useContext(UserInfoContext);
  const fiscalYearMonthName = useContext(FiscalYearContext);
  useEffect(() => {
    if (isFailed(asyncReport)) {
      setEnhancedReport(previousValue => Object.assign({}, previousValue, asyncReport));
    }
  }, [asyncReport]);
  useEffect(() => {
    if (!isSucceeded(sortableAsyncReport)) {
      return;
    }
    const {
      data: currentReport
    } = sortableAsyncReport;
    if (!previousReport || !reportsEqual(currentReport, previousReport)) {
      /*
        The below code destroys (temporarily while reloading) downstream components, including those that render
        the report itself, whenever a report is updated by the external consumer. This
        caused pagination state, which is maintained downstream, to reset each time
        a report is updated. While we are not yet certain this isn't what we want to do
        going forward, it is a deviation from what was occuring before where, when a report
        is updated, the existing pagination offset would be re-applied and retain the page
        position. With that in mind, we are temporarily omitting this behavior to remedy the
        issue it caused that is described in this thread:
         https://hubspot.slack.com/archives/CPLH0B5B7/p1669755070772629
      */
      // setEnhancedReport({
      //   status: AsyncStatus.STARTED,
      // });

      const addDrilldown = allowDrilldown && !hasCustomVisualize ? drilldownDecorator(currentReport, {
        fiscalYearMonthName,
        gates
      }) : Promise.resolve(currentReport);
      addDrilldown.then(reportWithDrilldownHandler => {
        return reportWithDrilldownHandler;
      }).then(updatedReport => {
        setPreviousReport(currentReport);
        setEnhancedReport({
          data: updatedReport,
          status: AsyncStatus.SUCCEEDED
        });
      }).catch(error => {
        setEnhancedReport({
          error,
          status: AsyncStatus.FAILED
        });
      });
    }
  }, [allowDrilldown, fiscalYearMonthName, gates, hasCustomVisualize, previousReport, sortableAsyncReport]);
  return enhancedReport;
}